import React from 'react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { AppImage } from '../AppImage';
import { capabilityGroups } from '../../data/about';
import { capabilitiesImage } from '../../data/aboutImages';
import { buildTools } from '../../data/site';
export function CapabilitiesSection() {
  return <Section bordered labelledBy="capabilities-title" data-id="element-20" data-mp="3q5610kpm0x2a">
      <Container data-id="element-21" data-mp="hss2phk91aqv">
        <Reveal data-id="element-22" data-mp="hs8i1t37s895">
          <h2 id="capabilities-title" className="max-w-[16ch] text-[40px] leading-[1.05] tracking-[-0.03em] text-ink lg:text-[56px]" data-id="element-23" data-mp="hpm9bq4l7mpc">
            Capabilities, and what we build on.
          </h2>
          <p className="mt-6 max-w-[52ch] text-body text-muted" data-id="element-24" data-mp="dpvgzhzewyip">
            Everything listed here is done in the studio or by a specialist we brief and manage. If
            something is outside it, we will tell you and point you at someone better.
          </p>
        </Reveal>

        <Reveal delay={0.06} className="mt-14 lg:mt-16" data-id="element-25" data-mp="jf93o72ah3ri">
          <AppImage src={capabilitiesImage.image} alt={capabilitiesImage.alt} ratio="16:10" data-id="element-26" data-mp="jfr7ppv70m9z" />
        </Reveal>

        <div className="mt-14 grid gap-10 border-t border-hairline pt-10 md:grid-cols-3 md:gap-8 lg:mt-16" data-id="element-27" data-mp="ehz3pxh9x9pf">
          {capabilityGroups.map((group, index) => <Reveal key={group.title} delay={index * 0.06} data-id="element-28" data-mp="oe2f7ty0mkp1" data-mpi={index}>
              <h3 className="text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-29" data-mp="12e3ith5o0687">{group.title}</h3>
              <ul className="mt-5" data-id="element-30" data-mp="xf0c7sa1dry4">
                {group.items.map(item => <li key={item} className="border-b border-hairline py-3 text-small leading-6 text-ink first:border-t" data-id="element-31" data-mp="xcxndbkme4uz">
                    {item}
                  </li>)}
              </ul>
            </Reveal>)}
        </div>

        <Reveal delay={0.12} className="mt-16 lg:mt-20" data-id="element-32" data-mp="1l28k8hyunf3u">
          <p className="text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-33" data-mp="1h4aosxehjws0">Platforms</p>
          <ul className="mt-6 flex flex-wrap gap-x-10 gap-y-4 border-t border-hairline pt-6 lg:gap-x-14" data-id="element-34" data-mp="1o78w9zt31hrt">
            {buildTools.map(tool => <li key={tool} className="text-[18px] font-medium tracking-[-0.02em] text-ink" data-id="element-35" data-mp="1t2xxs8onx8qr">
                {tool}
              </li>)}
          </ul>
        </Reveal>
      </Container>
    </Section>;
}